import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { adminApi, useNoIndex } from '../components/admin/adminApi';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [reveal, setReveal] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useNoIndex();

  useEffect(() => { adminApi.me().then(ok => { if (ok) navigate('/admin/discovery', { replace: true }); }); }, [navigate]);

  const submit = async e => {
    e.preventDefault();
    setBusy(true); setError('');
    const result = await adminApi.login(password);
    setBusy(false);
    if (result.ok) { setPassword(''); navigate('/admin/discovery', { replace: true }); }
    else setError(result.error);
  };

  return <main className="admin-login-wrap" data-testid="admin-login-page">
    <div className="admin-login-card">
      <img src="/brand/techspitze-logo.webp" alt="TechSpitze" data-testid="admin-login-logo" />
      <h1 data-testid="admin-login-heading">Team sign in</h1>
      <p data-testid="admin-login-subtitle">Enter the shared TechSpitze password to open the discovery dashboard.</p>
      <form onSubmit={submit}>
        <div className="admin-password-field">
          <input type={reveal ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Company password" autoComplete="current-password" aria-label="Company password" data-testid="admin-password-input" />
          <button type="button" className="admin-password-toggle" onClick={() => setReveal(!reveal)}
            aria-label={reveal ? 'Hide password' : 'Show password'} data-testid="admin-password-toggle">
            {reveal ? <EyeOff size={17} /> : <Eye size={17} />}
          </button>
        </div>
        {error && <p className="admin-login-error" role="alert" data-testid="admin-login-error">{error}</p>}
        <button type="submit" className="admin-btn admin-btn-primary" disabled={busy || !password} data-testid="admin-login-submit">
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <p className="admin-login-foot" data-testid="admin-login-foot"><Lock size={11} style={{ display: 'inline', marginRight: 6 }} />TechSpitze team only · sessions last 12 hours</p>
    </div>
  </main>;
}
